<template>
    <nav class="navbar navbar-default navbar-fixed-top">
        <div class="col-lg-8 col-lg-offset-2" style="padding-right: 30px; padding-left: 10px;">
            <div class="navbar-header">
                <router-link to="/" class="navbar-brand">
                    <img class="logo" src="../assets/logo.png" alt="Celtra" />
                    <strong>Celtra Status Board</strong>
                </router-link>
            </div>
            <div id="navbar" class="navbar-collapse collapse">
                <ul class="nav navbar-nav navbar-left">
                    <li>
                        <router-link to="/report">
                            <icon name="line-chart" class="icon"></icon>Uptime report
                        </router-link>
                    </li>
                </ul>
                <ul class="nav navbar-nav navbar-right" v-if="isAuthenticated">
                    <li>
                        <router-link to="/saturday">
                            <icon name="plus" class="icon"></icon>Saturday deploy
                        </router-link>
                    </li>
                    <li>
                        <router-link to="/new">
                            <icon name="plus" class="icon"></icon>Report incident
                        </router-link>
                    </li>
                    <li>
                        <a @click.prevent="userLogout" class="icon-label">
                            <icon name="sign-out" class="icon"></icon>Logout
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
import { NotificationsMixin } from "./mixin"

export default {
    name: "Navbar",
    mixins: [NotificationsMixin],
    computed: {
        ...mapGetters(["isAuthenticated"])
    },
    methods: {
        ...mapActions(["logout"]),
        userLogout() {
            this.logout().then(() => {
                this.$router.push("/")
                this.showSuccessMsg({
                    title: "Success.",
                    message: "Logged out!"
                })
            }).catch((error) => {
                this.showErrorMsg({
                    title: "Error logging out!",
                    message: error
                })
            })
        }
    }
}
</script>

<style scoped>
.logo {
    height: 40px;
    width: 40px;
    float: left;
    margin-top: -8px;
    margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue